import { IconButton, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridEntry } from '../entry/GridEntry';

export const FryerEntry = ({id, name, hersteller, handleChangeSearch, auth})  =>
{
  
    function renderCardContent (name, hersteller) {
      return (<>
        <Typography gutterBottom variant="h6" component="div">
          {name}
        </Typography>
        <Typography color='secondary' marginBottom={'10px'} alignItems={'center'} display={'flex'}><strong>Hersteller:</strong> &nbsp;{hersteller}</Typography>
      </>
      )
    };

    function renderCardActions (id, handleChangeSearch) {

      const handleDelete = (id) => {
          const requestOptions = {
            method: 'DELETE'
        };

        fetch('/api/fryer/'+id, requestOptions)
        .then(r => handleChangeSearch({target: {value: ""}}))
        .catch(err => console.error(err));
      };

      return(<>
        {!!auth && (<Tooltip title='bearbeiten'>
            <IconButton href={"/fryer/detail/"+id} size="medium" color="secondary" aria-label="edit">
                <EditIcon fontSize="medium" />
            </IconButton>
        </Tooltip>)}
        {!!auth && (<Tooltip title='löschen'>
            <IconButton onClick={(event)=> handleDelete(id)} size="medium" color="error" aria-label="delete">
                <DeleteIcon fontSize="medium" />
            </IconButton>
        </Tooltip>)}
      </>);
    };

    return (
      <GridEntry
        cardContent={renderCardContent(name, hersteller)}
        cardActions={renderCardActions(id, handleChangeSearch)}
        expandContent={null}
       />
    );
};